import { render } from "./ProfileOverview.vue?vue&type=template&id=6c308aa0&scoped=true"
import script from "./ProfileOverview.vue?vue&type=script&lang=js"
export * from "./ProfileOverview.vue?vue&type=script&lang=js"

import "@/css/components/profile-overview.css?vue&type=style&index=0&id=6c308aa0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c308aa0"]])

export default __exports__